module.exports = (__webpack_require__("49fU"))(13);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/object-assign/index.js from dll-reference vendor_library
// module id = BEQ0
// module chunks = 24